/* @ngInject */
function PostCategoriesController ($scope, $rootScope, $state, $q, $translate, MessageService, AdminService, ModalService) {
  const getCreatePostCategoryDialogController = () => $q.when(import('../../dialogs/create-post-category/create-post-category-dialog.controller'))

  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId
  // Used for pagination - $top=20
  $scope.iCurrentTop = 20
  $scope.iTokensCount = $rootScope.isDesktop ? 10 : 5
  $scope.loading = true
  $scope.aPostCategories = []
  $scope.pageTitle = ''

  const api = {
    getCreatePostCategoryDialogController
  }
  this.getApi = () => api

  $translate.onReady(() => {
    $scope.pageTitle = $translate.instant('categories')
  })

  function handleGetCategoriesResponse (oRes) {
    $scope.iPostsCategoriesCount = oRes.d.__count

    $scope.loading = false

    var bHasResults = oRes && oRes.d.results
    if (!bHasResults) {
      return
    }

    $scope.aPostCategories = oRes.d.results
  }

  function handleGetCategoriesError (oResponse) {
    $scope.loading = false
  }

  $scope.skipPagingTo = function (iToken) {
    $scope.loading = true
    AdminService.getPostCategories($scope.iCurrentTop, $scope.iCurrentTop * iToken).then(handleGetCategoriesResponse).catch(handleGetCategoriesError)
  }

  AdminService.getPostCategories($scope.iCurrentTop).then(handleGetCategoriesResponse).catch(handleGetCategoriesError)

  $scope.deletePostCategory = function (oPostCategory, iIndex) {
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureDeleteCategory'),
      cancelButton: $translate.instant('no'),
      confirmButton: $translate.instant('yes'),
      dangerMode: true,
      closeOnConfirm: true,
      press: function () {
        $scope.loading = true
        AdminService.deletePostCategory(oPostCategory.id, oPostCategory.productId)
          .then(function () {
            $scope.aPostCategories.splice(iIndex, 1)
            $scope.loading = false
          }).catch(handleGetCategoriesError)
      }
    })
  }

  $scope.openFormCategoryModal = function (oPostCategory) {
    api.getCreatePostCategoryDialogController().then(({ CreatePostCategoryDialogController }) => {
      oPostCategory = oPostCategory || {}

      ModalService.showModal({
        templateId: 'createPostCategory.html',
        templateUrl: '/admin/dialogs/create-post-category/create-post-category-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        data: {
          oPostCategory: oPostCategory
        },
        controller: CreatePostCategoryDialogController
      })
        .then(function (bReloadList) {
          if (bReloadList) {
            $scope.loading = true
            AdminService.getPostCategories($scope.iCurrentTop).then(handleGetCategoriesResponse).catch(handleGetCategoriesError)
          }
        })
    })
  }

  $scope.headerNavigation = {
    buttons: [{
      type: 'button',
      btnType: 'primary',
      label: $translate.instant('newCategory'),
      icon: 'plus',
      onClick: $scope.openFormCategoryModal
    }]
  }
}

export { PostCategoriesController }
